module.exports = __webpack_public_path__ + "media/images/webpage/shared/ogp-d1bc5c9dc364f1815ab5f66ae27a4ecb.webp";